<template>
<div id="app">
  <header>
    <navigation />
  </header>

  <!-- Begin page content -->
  <main role="main" class="container">
    <router-view />
  </main>

  <footer class="footer">
    <div class="container">
      <span>Copyright 2000 - 2020 MBN</span>
    </div>
  </footer>
</div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
export default {
  name: 'App',
  components: {
    'navigation': Navigation,
  }
}
</script>

<style>
html {
  position: relative;
  min-height: 100%;
}

body {
  margin-bottom: 60px;
  background-color: #42593c;
  background-image: url('./assets/map.png');
  background-repeat: no-repeat;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #343a40;
  color: #ffffff;
}

body>.container {
  padding: 60px 15px 0;
}

.footer>.container {
  padding-right: 15px;
  padding-left: 15px;
}
</style>
